module.exports = __webpack_public_path__ + "img/about-us.f9169ec4.png";